import script from "./QuillEditorToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./QuillEditorToolbar.vue?vue&type=script&setup=true&lang=js"

import "./QuillEditorToolbar.vue?vue&type=style&index=0&id=4d3584ed&lang=scss"

export default script